<template>
    <div class="clients-teaser grid grid__base">
        <div class="grid--container">
            <div class="grid--row" v-if="title">
                <div class="grid--col">
                    <h2 class="clients-teaser--title">{{ title }}</h2>
                </div>
            </div>
        </div>

        <div class="clients-teaser--container grid--container">
            <div class="grid--row">
                <div class="clients-teaser--col grid--col">
                    <auto-slider
                            :item-count="itemCount"
                    >
                        <slot/>
                    </auto-slider>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import AutoSlider from 'framework/components/auto-slider/auto-slider';

    export default {
        components: { AutoSlider },
        props: {
            title: {
                type: String,
                default: null,
            },

            itemCount: {
                type: Number,
                required: true,
            },


        },

    };
</script>
